import { render, staticRenderFns } from "./custInterest.vue?vue&type=template&id=384478d5&scoped=true&"
import script from "./custInterest.vue?vue&type=script&lang=js&"
export * from "./custInterest.vue?vue&type=script&lang=js&"
import style0 from "./custInterest.vue?vue&type=style&index=0&id=384478d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384478d5",
  null
  
)

export default component.exports